const extensionsStorage: Map<string, Promise<string>> = new Map();

export default extensionsStorage;
